import useNTGroupRoleTypeDropdown from './UseNTGroupRoleTypeDropdown';

import Dropdown from '@usas/ui-web/components/dropdowns/Dropdown';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const NTGroupRoleTypeDropdown = ({ label, name, value, error, message, onChange }) => {
  const { nationalTeamGroupRoleTypesState } = useNTGroupRoleTypeDropdown();

  return nationalTeamGroupRoleTypesState.message
    ? <span className={global.LoadingMsg}>{nationalTeamGroupRoleTypesState.message}</span>
    : (
      <Dropdown
        name={name}
        value={value}
        error={error}
        label={label}
        message={message}
        onChange={onChange}
        options={nationalTeamGroupRoleTypesState.options || []}
        isLoading={nationalTeamGroupRoleTypesState.areOptionsLoaded !== true}
      />
    );
};

export default NTGroupRoleTypeDropdown;